import * as accountGenerator from './microaccount/modules/account-generator/';
import taxPaymentV2 from './microaccount/modules/tax-payment-v2/'
import paymentTax from './microaccount/modules/payment-tax/'

import '../scss/microaccount.scss';
// import '../shared/';
// import '../satelity/modules/faq';


window.addEventListener('load', () => {
  accountGenerator.init();
  taxPaymentV2;
  paymentTax;
});